import { useContext } from 'react';
import { ProfileContext } from 'app/contexts/profile-context';

const useProfile = () => {
  return useContext(ProfileContext);
};

export default useProfile;
